// Constants
import { CompanyName } from '../../utils/Constants';
import { HOME_PAGE_URL } from '../../utils/Routes';
// Images
import MainLogo from '../../assets/images/logos/lady-cender-dominatrix-goddess-logo3.webp';

function IndexPageMainContainer() {
  return (
    <header
      className='grid w-full h-full text-colour1 bg-colour2/80 dark:text-colour1 z-10'
      role='banner'
      aria-label={`${CompanyName} — Neon-Gothic Hypnosis & Sessions`}
    >
      <div className='grid relative text-center items-center gap-8 lg:container lg:mx-auto lg:max-w-2xl'>
        {/* Identity / Logo */}
        <section className='grid h-full items-center'>
          <img
            src={MainLogo}
            alt={`${CompanyName} neon-gothic logo`}
            className='w-full animate-fade-in'
            decoding='async'
            loading='eager'
            fetchpriority='high'
          />
        </section>

        <div className='grid h-fit px-8 gap-y-4'>
          {/* Hero copy */}
          <div className='grid gap-y-4 w-full items-center'>
            <h1 className='text-xs lg:text-base font-titleFont tracking-wider'>
              If you like it? I’ll torture you with it — beautifully, precisely,
              and always consensually. <br /> Know that If you like it, I’ll
              torture you with it. I’ll infiltrate your brain and lick your
              synapses until you beg for more.
            </h1>
            {/* <h1 className='text-xs lg:text-base font-titleFont tracking-wider'>
              Step into my palace of neon gothic power <br /> I am not just a
              goddess, but a deity, and you will burn to serve beneath my
              ever-watching eyes.
            </h1> */}
            <h2
              id='age-warning'
              className='font-fancyFont text-2xl lg:text-3xl'
            >
              You must be over 18!
            </h2>
          </div>

          {/* CTA Buttons */}
          <section
            className='grid gap-y-4 lg:gap-y-2 h-fit mt-4'
            aria-label='Age confirmation'
          >
            <a
              href={HOME_PAGE_URL}
              aria-label='Enter — I confirm I am over 18'
              aria-describedby='age-warning'
              className='bg-colour2/50 font-serif uppercase border-2 border-solid border-colour1 lg:normal-case text-xl lg:font-titleFont lg:text-xs py-1 lg:py-2 text-colour1 rounded-md shadow-md shadow-colour1/10 hover:bg-colour6 active:bg-colour6'
            >
              <span>Yes Goddess</span>
            </a>

            <a
              href='https://google.com'
              aria-label='Leave now — I am not over 18'
              target='_blank'
              rel='noopener noreferrer'
              className='bg-colour1 hover:brightness-90 lg:text-xs py-1 lg:py-2 font-serif uppercase lg:normal-case text-xl lg:font-titleFont text-colour2 rounded-md shadow-md shadow-colour1/10 tracking-wider'
            >
              <span>Leave Now</span>
            </a>
          </section>

          {/* Legal & copyright */}
          <section
            className='grid gap-y-2'
            aria-label='Site legal and copyright'
          >
            <div className='grid justify-center mx-auto max-w-2xl text-xxs'>
              <p className='text-xs'>
                DISCLAIMER: {CompanyName} DOES NOT ENGAGE IN ANY ILLEGAL
                ACTIVITIES.
              </p>
            </div>
            <div>
              <p className='text-xs' aria-label='Copyright notice'>
                ©{' '}
                <time dateTime={String(new Date().getFullYear())}>
                  {new Date().getFullYear()}
                </time>{' '}
                {CompanyName}
              </p>
            </div>
          </section>
        </div>
      </div>
    </header>
  );
}

export default IndexPageMainContainer;
